import styled from '@emotion/styled';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const AddressBar = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 1rem;
	background: #404040;
	color: white;
	padding: 0.75rem 1.5rem;
	transform: translateY(50%);
`;

const Image = styled.img`
	width: 100%;
	height: 40rem;
	object-fit: cover;
`;

export default function MapBlockEpsilon({ street }: { street: string }) {
	return (
		<Section id="map">
			<AddressBar>Address</AddressBar>
			<Image src={street} />
		</Section>
	);
}
